import React from 'react'

import Link from 'next/link'

import classNames from 'classnames'

import Container from '~/components/atoms/Container/Container'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './HeaderCTA.module.css'

interface HeaderCTAProps {
  variant?: 'light' | 'dark'
}

const HeaderCTA: React.FC<HeaderCTAProps> = ({ variant = 'dark' }) => {
  return (
    <div className={classNames(styles.base, styles[`${variant}Base`])}>
      <Link href="mailto:enquiries@myartbroker.com?subject=I'd like to be added to the Directory">
        <Container>
          <div className={styles.container}>
            <Text size={TextSizes.bodyLrg} className={styles.title}>
              Enquire to Feature in THE<em>DIRECTORY</em>
            </Text>
            <div className={styles.icon}>
              <Icon type={'Arrow'} width={20} />
            </div>
          </div>
        </Container>
      </Link>
    </div>
  )
}

export default HeaderCTA
